import { createContext } from 'react';

/**
 * allow passing content context (ie - is form showing in full width) to inner components
 */
export const ContentContext = createContext({ fullWidth: true });
